module.exports = __webpack_public_path__ + "static/img/new.1a4c178d.svg";